import { Container, Graphics } from 'pixi.js';

interface Particle {
  gfx: Graphics;
  vx: number;
  vy: number;
  life: number;
  maxLife: number;
  rotateSpeed: number;
}

export class ParticleEmitter {
  public container: Container;
  private particles: Particle[] = [];

  constructor() {
    this.container = new Container();
  }

  public burst(x: number, y: number, color: number = 0xffd32a, count: number = 10, shape: 'square' | 'line' | 'circle' = 'square') {
    for (let i = 0; i < count; i++) {
      const g = new Graphics();
      const size = 3 + Math.random() * 4;

      if (shape === 'line') {
        g.moveTo(-size, 0);
        g.lineTo(size, 0);
        g.stroke({ width: 2, color });
      } else if (shape === 'circle') {
        g.circle(0, 0, size / 2);
        g.fill({ color });
      } else {
        g.rect(-size / 2, -size / 2, size, size);
        g.fill({ color });
      }

      g.position.set(x, y);
      this.container.addChild(g);

      const angle = Math.random() * Math.PI * 2;
      const speed = 1.5 + Math.random() * 5;

      this.particles.push({
        gfx: g,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        life: 0,
        maxLife: 20 + Math.random() * 25,
        rotateSpeed: (Math.random() - 0.5) * 0.3
      });
    }
  }

  public update(delta: number) {
    for (let i = this.particles.length - 1; i >= 0; i--) {
      const p = this.particles[i];
      p.life += delta;
      p.gfx.position.x += p.vx * delta;
      p.gfx.position.y += p.vy * delta;
      p.vx *= 0.94;
      p.vy *= 0.94;
      p.gfx.rotation += p.rotateSpeed * delta;
      p.gfx.alpha = 1 - p.life / p.maxLife;

      if (p.life >= p.maxLife) {
        this.container.removeChild(p.gfx);
        p.gfx.destroy();
        this.particles.splice(i, 1);
      }
    }
  }

  public clear() {
    for (const p of this.particles) {
      this.container.removeChild(p.gfx);
      p.gfx.destroy();
    }
    this.particles = [];
  }
}
